<script>
  import { onMount } from 'svelte'
  import { db } from '../util.js'

  let content = 'Loading...'
  let title = ''

  onMount(() => {
    db.get('/about.json').then(data => {
      content = data.body
      document.title = title = data.title
    })
  })
</script>

<!--<iframe src="https://player.vimeo.com/video/208335372?autoplay=1&muted=1;loop=1" title="Sunvair Facilities" style="width: 100vw; height: 60vw;" frameborder="0" allowfullscreen="true"></iframe>-->
<!--
<div class="text">
  <h1>{title}</h1>
  {@html content}
</div>
-->
<!-- INTRO SECTION --> 

		 

		 
		<div class="intro-bg-flex wow fadeInRight" style="background-image: url(/img/b737.jpg); visibility: visible; animation-name: fadeInRight;"></div>
		
		<div class="inner">
			<div class="intro-flex-text">
				<h1 class="wow fadeInLeft" style="visibility: visible; animation-name: fadeInLeft;">OVERVIEW</h1>
				
				<div class="wow fadeInLeft" data-wow-delay=".15s" style="visibility: visible; animation-delay: 0.15s; animation-name: fadeInLeft;">
					<p>Sunvair Aerospace Group is a vertically integrated, privately held small business headquartered in Southern California.</p>
<p>We are comprised of three business units: Sunvair, AAIC, and Aerospace Plating.</p>
<p>Sunvair and Aerospace Plating are located in Valencia, California, with AAIC based in Long Island, New York. Both facilities are within minutes of Los Angeles International Airport (LAX) and John F. Kennedy (JFK) respectively.</p>
<p>To download our 2019 corporate brochure, <a href="/download/Sunavir-Group-2020.pdf" target="_blank" rel="noopener"><strong>click here</strong></a>.</p>
	
				</div>
			</div>
		</div>
 <div class="container-flexible" id="maincontent">
									<div class="image-box clear flex-section">
						<div class="inner">
							<div class="features-inner">
								<div class="left-50">										
  																	<div class="features-left wow fadeInLeft" style="background: rgba(0, 0, 0, 0) url(/img/737.jpg) no-repeat scroll 50% 50% / cover; visibility: visible; animation-name: fadeInLeft;">
										<img src="/img/737.jpg" x="700x878.jpg" class="attachment-capability-thumb size-capability-thumb" alt="MEC Employee in Ejector Systems Assembly" width="700" height="878"> 
									</div>
								</div>

								<div class="right-50">
									<div class="features-right wow fadeInRight" style="visibility: visible; animation-name: fadeInRight;">
										<h3>Our People and Culture</h3>
<p>The Marvin Group understands that we are in the business of serving people, whether its supporting our warfighters when they go into harms way, or ensuring that our employees and their families have access to stable and rewarding career opportunities.</p>
<p>As a family-owned business, we are aware of the unique challenges that accompany this and we continue to look to develop the talent already within our business, as well as recruit promising new talent which will challenge the status quo and assist in the continued growth of The Marvin Group.</p>
<p>Fundamentally, we are driven by our core values of Integrity, Partnership, Can-Do Attitude, and Innovation and intent on delivering on the promise of our vision, honed over more than 5 decades:</p>
<p><em><strong>The best people delivering confidence and security to warfighters all over the world.&nbsp;</strong></em></p>
<p>&nbsp;</p>

																			</div>
								</div>
							</div>
						</div>
					</div>
					
									<div class="center-text flex-section">
						<div class="inner">
							<div class="center-text-inner">
								<p>"The Marvin Group has always believed in people. From the beginning, our founders understood that finding the right people, and providing them a place where they could realize their full potential was critical to the overall success of the business. We've always been proud that we provide an environment where people's talents can be recognized and rewarded."<br>
<br>
- Howard Gussman, Chairman &amp; Chief Executive Officer, The Marvin Group</p>
							</div>
						</div>
					</div>
					
				
				<!-- BOX AND IMAGE SECTION --> 
									<div class="box-image flex-section">
						<div class="inner clear">
							<div class="left-50 box-image-left wow fadeInLeft" style="visibility: visible; animation-name: fadeInLeft;">
								<div class="box-image-left-inner">
									<h3>Our Capabilities</h3>
<p>The Marvin Group is a vertically integrated Aerospace &amp; Defense organization, which leverages its relatively unique position in the market to provide both value and reliability to our partners and customers.</p>
<p>Our three core business units serve the Air &amp; Space, Land and Naval domains with quality products and technical services, and we support a wide range of U.S. and Western manufactured aircraft, ground vehicles and increasingly, maritime platforms.</p>
<p>The Marvin Group has developed nearly unrivaled capabilities to support its customer base in the areas of its business units core competencies, which include:</p>
<ul>
<li>Airborne Stores Carriage and Release Equipment &amp; Aircraft Auxiliary Equipment</li>
<li>Automated Aerospace &amp; Military Test Equipment from the Flightline to Depot</li>
<li>Power &amp; Thermal Management Solutions for Land &amp; Maritime Platforms</li>
</ul>
									
																			<a href="/capabilities/" class="read-more dark" data-wow-delay=".7s">Explore Full Capabilities<span class="screen-reader-text">Explore Full Capabilities</span></a>
																	</div>
							</div>
							
																
							<div class="right-50 box-image-right wow fadeInRight" style="background: rgba(0, 0, 0, 0) url(/img/737.jpg) no-repeat scroll 50% 50% / cover; size: 700x615; visibility: visible; animation-name: fadeInRight;">
								<img src="/img/737.jpg" class="attachment-700x615 size-700x615" alt="F-15 on runway" width="700" height="615"> 
															</div>
						</div>
					</div>
					
					<div class="full-two-col flex-section">
						<div class="inner">
							<div class="testimonials-row wow fadeInLeft" style="visibility: visible; animation-name: fadeInLeft;">
								<div class="sub-title">Leadership</div>
                <p>MRO is about specialization, but underpinning that service expertise are the people who build MRO businesses. Our visionary leadership team, many with long tenures at the Sunvair Group companies, have built upon our culture of innovation to make these companies what they are today.</p>

<p>Kerry Jarandson</p>
<p>Chief Executive Officer, Sunvair</p>
<p>&nbsp;</p>

<p>Dale Roberts</p>
<p>President, AAIC</p>
<p>Dale brings over 20 years of senior management experience in the aerospace industry to his current position as president of AAIC where he is responsible for running all facets of the business.&nbsp; Prior to AAIC, he was the COO for Sunvair&rsquo;s Landing Gear group, and prior to that, was Acting GM and Senior Director of Plant Operations for Erickson Inc. Dale has an extensive engineering management background as well as having been an FAA Designated Engineering Representative for over 15 years. Dale is a retired USAF officer and holds an MS in Aerospace Engineering from the University of Dayton and a BS in Aerospace Engineering from the University of Oklahoma.</p>
<p>&nbsp;</p>
<p>Glenn Miller</p>
<p>Chief Financial Officer, Sunvair</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>Puya Parniani</p>
<p>Chief Operating Officer, Sunvair</p>
<p>Puya started his career in business consulting, later honing his expertise in aerospace while at Lufthansa Technik where he specialized in MRO, Lean Management, Engineering and Strategic Planning. For the Sunvair Aerospace Group, Puya supervises all production departments, coordinating activities in personnel management, quality control, production control, program management, and engineering.&nbsp; With his experience, he ensures the highest standards of quality are maintained, implements continuous improvement, and facilitates best practices and change management in support of company strategy. &nbsp;&nbsp;Puya earned his Master of Business Engineering Science from the University of Hamburg and is also a certified Lufthansa Technik Lean Management Facilitator with two Lean stars.</p>
<p>&nbsp;</p>
<p>Mike Dann</p>
<p>Vice-President, Business Development, Sunvair</p>
<p>Mike's 20 years of senior sales management experience at Sunvair includes marketing strategies, implementation, sales execution, and contract negotiations.&nbsp; He has been instrumental in growing Sunvair from a small family owned business into a major MRO provider of aerospace landing gear service. Prior to Sunvair, Mike filled various Senior Management positions in the beverage industry in Southern and Central California.&nbsp; He matriculated at California State University Humboldt with a dual degree in Business Management and Marketing.</p>
<p>&nbsp;</p>
<p>Jay Perez</p>
<p>Vice President Sales &amp; Marketing, AAIC</p>
<p>Jay previously served as Interim President at AAIC and now oversees all sales, business development, marketing, and customer service. Prior to AAIC, he was the Vice President of Materials at ExpressJet Airlines, in charge of the purchasing, repair and warranty, AOG desk, and warehousing &amp; distribution groups.&nbsp; Between 2004 and 2010, Jay served on the Board of Directors of ExpressJet Services and Saltillo Jet Center as a strategic advisor.&nbsp; He also held various management positions at Express Jet and Continental Airlines during his 25 year airline career.&nbsp; Jay studied Business Management at Winthrop University in Rock Hill, South Carolina.</p>
<p>&nbsp;</p>
<p>Jessie Rivera</p>
<p>Human Resources</p>
<p>Jessie is responsible for hiring, training, safety, benefits administration and employee engagement. He also advises our plating shop on regulatory and process related issues as well as business development. Jessie joined Sunvair in 2007 as the General Manager of our plating shop and was key in it gaining Nadcap Merit status. Before Sunvair, Jessie spent several years at General Motors as well as Lockheed working on the P3 Orion and Rockwell working on the B1 Bomber. He matriculated at the University of California at Santa Barbara and earned a degree in Human Resource Management at Trevecca Nazarene University in Nashville, Tennessee. &nbsp;</p>
<p>&nbsp;</p>
<p>Margarita Margolin</p>
<p>Financial Controller, Aviation Avionics and Instruments, Inc.</p>
<p>Having joined AAIC in 2016, Margarita oversees accounting, financial reporting and Human Resources at the company.&nbsp; Margarita works closely with the AAIC President and Sunvair Group CFO in the execution of treasury management, budgeting, forecasting, business analytics and financial audit interface.&nbsp; Previously, Margarita worked as a manager at WPP in their financial reporting group for 8 years.&nbsp; Prior to that, she worked as an external auditor at PWC for 3 years during which time she earned her CPA.&nbsp; Margarita graduated in 2004 with a B.S. in Accounting from Binghamton University.</p>
							</div>
						</div>
					</div>
					<!--
          <div class="full-two-col flex-section">
						<div class="inner">
							<div class="testimonials-row wow fadeInLeft" style="visibility: visible; animation-name: fadeInLeft;">
								<div class="sub-title">Leadership</div>
								<div class="testimonials-left">									
									<h3>Worldwide Support for U.S. &amp; Allied Warfighters</h3>
								</div>
								<div class="testimonials-right">
									<p></p>
                  <p></p>
								</div>
							</div>
						</div>
					</div>
					-->
					<div class="image-box clear flex-section">
						<div class="inner">
							<div class="features-inner">
								<div class="left-50">										
  																	<div class="features-left wow fadeInLeft" style="background: rgba(0, 0, 0, 0) url(/img/737.jpg) no-repeat scroll 50% 50% / cover; visibility: visible; animation-name: fadeInLeft;">
										<img src="/img/737.jpg" class="attachment-capability-thumb size-capability-thumb" alt="F-35 and F-16 in flight" width="700" height="775"> 
									</div>
								</div>

								<div class="right-50">
									<div class="features-right wow fadeInRight" style="visibility: visible; animation-name: fadeInRight;">
										<h3>Environmental Responsibility</h3>
<p>Sunvair Aerospace Group recognizes the importance of protecting the envirnment, not only to our local community, but to veterans, as well as supporting the fight against cancer and ensuring that we minimize our environmental impact.</p>
<p>In recent years we have rolled out a variety of employee incentive and recognition programs and will continue to do so to help ensure that we attract and retain the best people so we can succeed at our mission.</p>

																			</div>
								</div>
							</div>
						</div>
					</div>
					
				
				<!-- BOX AND IMAGE SECTION --> 
									<div class="box-image flex-section">
						<div class="inner clear">
							<div class="left-50 box-image-left wow fadeInLeft" style="visibility: visible; animation-name: fadeInLeft;">
								<div class="box-image-left-inner">
									<h3>Our Quality</h3>
                  <p>
                 Engineered reliability to keep you flying safely is how we define our brand across all our companies.
                 That is why we work relentlessly to be the industry leader in safety, reliability, quality, and customer service.
                 To deliver on that promise, we take a holistic approach to optimizing our production ecosystem, employing the principles of lean management and continuous improvement to advance our administration and production at every point - employees, management systems, technology and processes.
                 We hold regular 6S workshops and audits to ensure a clean, safe and efficient workplace.
                 And we implement the latest in automation to provide things like 24/7 monitoring and a paperless shop.
                 </p>

<p>Key performance measures across our organization focus on:</p>
<ul>
    <li>OTD and TAT targets</li>
    <li>Prioritization of quality and safety</li>
    <li>Continuous improvement from the bottom up</li>
</ul>
<p>
In addition to delivering the highest quality and reliability, our approach also results in more efficient use of resources, reduced costs, and improved turnaround times.
</p>
																			
                                      <p>
                                      <a href="/services" class="read-more dark" data-wow-delay=".7s">Explore Full Capabilities<span class="screen-reader-text">Explore Full Capabilities</span></a>
                                      </p>

<p>
Our commitment to transparent communications makes our customers' lives easier.
</p>

<p>
At any time during your part's overhaul or repair process, you can check the status of your repair to see exactly where your part is in the repair process and how soon it will be returned to you.  You will also receive real-time communications through our automated email update system.  When the work is complete, you'll receive tracking information for shipment and delivery.  All of your part's work history, inspections, and shipment are in one place that you can access 24/7.
</p>

 

<p>
Our Mission:  Repair Not Replace
</p>

<p>
We want to be your go-to provider for overhaul and repairs.  That is why it is our mission to use our expertise and state-of-the-art equipment to find a repair for your part.  If you have a hard-to-repair part, contact us.  We can help save you money with our repair rather than replace approach.
</p>

                                      <p>
                                      <a href="/contact" class="read-more dark" data-wow-delay=".7s">Contact Us<span class="screen-reader-text">Contact Us</span></a>
                                      </p>
								</div>
							</div>
							
																
							<div class="right-50 box-image-right wow fadeInRight" style="background: rgba(0, 0, 0, 0) url(/img/gear.jpg) no-repeat scroll 50% 50% / cover; visibility: visible; animation-name: fadeInRight;">
								<img src="/img/gear-detail.jpg" class="attachment-700x615 size-700x615" alt="F-35 on runway at twilight" width="700" height="495"> 
															</div>
						</div>
					</div>
								<!--END OF BOX AND IMAGE SECTION-->


</div>






<style>
  h1{
    padding: 0;
  }
  .text{
    margin: 40px 6%;
  }
</style>
